import React, { useState, useEffect, useContext } from "react";
import axios from "axios";

import { decryptText } from "../../utils/cipherText";

import { RouteSharp } from "@mui/icons-material";
import { FiDownload } from "react-icons/fi";
import { FaArrowLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import TableFooter from "../../components/TableFooter";
import ImageLoading from "../../components/ImageLoading";
import NoDataFound from "../../components/NoDataFound";
import { sideBarContext } from "../../App";

function Notification() {
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [users, setUsers] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const token = localStorage.getItem("token");
  const [filter, setFilter] = useState("all");
  const [noOfRows, setNoOfRows] = useState(0);
  const [noOfPages, setNoOfPages] = useState(10);
  const [startIndex, setStartIndex] = useState(0);

  const [pageNo, setPageNo] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [endIndex, setEndIndex] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [list, setList] = useState([]);
  const navigate = useNavigate();
  const { expanded } = useContext(sideBarContext);

  const fetchNotifications = async (controller) => {
    setNoData(false);
    setLoading(true);
    const token = localStorage.getItem("token");
    // console.log(token, "token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/dashboards/notifications?${
          filter !== "all" ? `search=${filter}&` : ``
        }per_page=${rowsPerPage}&page=${pageNo}`,
        options
      );
      if (res.data.notifications.length > 0) {
        setNoOfPages(res.data.total_pages);
        setNoOfRows(res.data.total_records);
        setList(res.data.notifications);
      } else {
        setNoData(true);
        setNoOfPages(res.data.total_pages);
        setNoOfRows(res.data.total_records);
      }
      setLoading(false);

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const getNotificationText = (status) => {
    if (!status) return "";
    switch (status) {
      case "pledged":
        return "has successfully pledged units of";
      case "disbursed":
        return "has successfully disbursed an amount";
      case "overdue_emi":
        return "has missed their last EMI of";
      case "prepayment_success":
        return "has completed prepayment of";
      default:
        return "";
    }
  };
  const filterData = [
    {
      name: "All",
      value: "all",
    },
    {
      name: "Pledging Update",
      value: "pledged",
    },
    {
      name: "Disbursal Update",
      value: "disbursed",
    },
    {
      name: "EMI Missed",
      value: "overdue_emi",
    },
    {
      name: "Prepayment",
      value: "prepayment_success",
    },
  ];

  useEffect(() => {
    const controller = new AbortController();
    fetchNotifications(controller);
    return () => {
      controller.abort();
    };
  }, [filter, pageNo, rowsPerPage]);

  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);
  return (
    <div
      className={`${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } bg-[#f1f1f6] h-[100vh] px-[20px] pt-[16px]`}
    >
      <div className=" bg-white h-24 px-4 flex flex-col justify-between pt-4 rounded-lg">
        <p className=" text-xl font-semibold flex items-center">
          <span className=" mr-4" onClick={() => navigate(-1)}>
            <button className=" flex items-center">
              <FaArrowLeft />
            </button>
          </span>
          Your Notification
        </p>
        <div className=" text-sm  space-x-8">
          {" "}
          {filterData.map((item, index) => (
            <button
              key={index}
              className={`   ${
                filter === item.value
                  ? "border-b-[3px] border-[#212b36]  font-semibold "
                  : ""
              }   py-[12px]`}
              onClick={() => {
                setPageNo(1);
                setFilter(item.value);
              }}
            >
              {item.name}
            </button>
          ))}
        </div>
      </div>
      {loading && (
        <div className="w-full h-[calc(100vh-185px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-[calc(100vh-185px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {!loading && !noData && (
        <div className=" px-4 mt-[12px] pt-[16px]   bg-white rounded-t-lg max-h-[calc(100vh-185px)] overflow-y-auto">
          {list?.map((item, index) => (
            <div
              className="px-6 flex items-center h-12 mb-1 hover:bg-[#f1f1f6]"
              key={index}
            >
              <p className="bg-[#f0f9ff] rounded-full h-[32px] w-[32px] flex items-center justify-center text-[#0710ed] text-sm font-bold mr-3">
                {item?.user_details?.name
                  ? item?.user_details?.name[0].toUpperCase()
                  : "--"}
              </p>

              <p className=" font-normal text-sm">
                <span className="font-semibold">
                  {item.user_details?.name || "--"}
                </span>
                {"  "}
                {getNotificationText(item.key)}{" "}
                <span className="font-semibold">
                  {"₹" + item.notification_details?.amount || "--"}
                </span>{" "}
                on{" "}
                <span className="font-semibold">{item.created_at || "--"}</span>
              </p>
            </div>
          ))}
        </div>
      )}

      <div className=" bg-white rounded-b-lg">
        <TableFooter
          totalPages={noOfPages}
          totalRows={noOfRows}
          rowsPerPage={rowsPerPage}
          startIndex={startIndex}
          setStartIndex={setStartIndex}
          setEndIndex={setEndIndex}
          endIndex={endIndex}
          setPageNo={setPageNo}
          pageNo={pageNo}
          setRowsPerPage={setRowsPerPage}
        />
      </div>

      {/* User Table */}
    </div>
  );
}

export default Notification;
